<div class="value-placeholder">
    <img class="pixelization" src="/assets/images/winmo/sneak-view/small-placeholder.svg" />
    <img *ngIf="lockIcon" class="locker" src="/assets/images/winmo/sneak-view/locker.svg" />
</div>
